import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL
export const getOrderItem = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.orderItem}/${id}`)
        return res
    } catch (error) {
        return Promise.reject(error); 
       }
}


export const getSingleOrderItem = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.orders}/${URLEndpoints.getOrder}/${id}`)
        const data = res.data.order
        console.log(data,"ORDER FOR SHIPPING")

        return res
    } catch (error) {
        return Promise.reject(error);    }
}
export const updateOrderItems = async (id,payload) => {
    try {
        const response=await axios.put(
            `${BASE_URL}/${URLEndpoints.orderItem}/${id}`,
            payload,
            {
                headers: {
                    accessToken: localStorage.getItem('accessToken')
                }
            }
        );
        return response.data
    } catch (error) {
        // Do not treat failed saves as successful mutations.
        throw error;
    }
}
// Called only after saving Edit Item in the Sales Order Cart. Does not
// alter snapshots, pricing, shipping or any generated Purchase Order.
export const rehydrateMissingCustomOrderItemSupplier = async (id, payload) => {
    const response = await axios.post(
        `${BASE_URL}/${URLEndpoints.orderItem}/${id}/rehydrate-custom-supplier`,
        payload,
        { headers: { accessToken: localStorage.getItem("accessToken") } }
    );
    return response.data;
};

export const addOrderOtherService = async (id,payload) => {
    try {
        const response=await axios.post(
            `${BASE_URL}/orders/${id}/${URLEndpoints?.otherService}`,
            payload,
            {
                headers: {
                    accessToken: localStorage.getItem('accessToken')
                }
            }
        );
        return response.data
    } catch (error) {
        console.log(error)
    }
}
export const deleteOrderItem = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/${URLEndpoints.orderItem}/${id}`,
        {
          headers: {
            accessToken: localStorage.getItem('accessToken')
          }
        }
      );
      return res.data;
    } catch (error) {
        alert(error)
      return Promise.reject(error);
    }
  };
  export const copyOrderItem = async (id) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/${URLEndpoints.orderItem}/${id}/duplicate`
      );
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getSingleOtherService = async (id) =>{
        try{
            const response = await axios.get(`${BASE_URL}/orders/${URLEndpoints?.otherService}/${id}`)
            return response.data.otherService
        }catch(error){
            console.log(error)
        }
}

export const updateOtherService = async (id,payload) =>{
        try{
            const response = await axios.put(
                `${BASE_URL}/orders/${URLEndpoints?.otherService}/${id}`,
                payload,
                {
                    headers: {
                        accessToken: localStorage.getItem('accessToken')
                    }
                }
            )
            return response
        }catch(error){
            console.log(error)
        }
}


export const deleteOtherService = async (id) =>{
        try{
            const response = await axios.delete(
                `${BASE_URL}/orders/${URLEndpoints?.otherService}/${id}`,
                {
                    headers: {
                        accessToken: localStorage.getItem('accessToken')
                    }
                }
            )
            return response.data
        }catch(error){
            console.log(error)
        }
}
